interface LocationParts {
  pathname: string
  search: string
  hash: string
}

function hasHashRoute(hash: string): boolean {
  return hash.startsWith('#/')
}

function getHashSearch(hash: string): string {
  const queryIndex = hash.indexOf('?')
  if (queryIndex === -1) return ''
  return hash.slice(queryIndex + 1)
}

function getHashPath(hash: string): string {
  const queryIndex = hash.indexOf('?')
  if (queryIndex === -1) return hash || '#/'
  return hash.slice(0, queryIndex) || '#/'
}

export function getSearchParamsFromLocation(location: LocationParts): URLSearchParams {
  if (hasHashRoute(location.hash)) {
    return new URLSearchParams(getHashSearch(location.hash))
  }

  return new URLSearchParams(location.search)
}

export function buildUrlWithSearchParams(location: LocationParts, params: URLSearchParams): string {
  const query = params.toString()

  if (hasHashRoute(location.hash)) {
    const hashPath = getHashPath(location.hash)
    const nextHash = query ? `${hashPath}?${query}` : hashPath
    return `${location.pathname}${location.search}${nextHash}`
  }

  return query ? `${location.pathname}?${query}` : location.pathname
}

export function getWindowSearchParams(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams()
  return getSearchParamsFromLocation(window.location)
}

export function replaceWindowSearchParams(params: URLSearchParams): void {
  if (typeof window === 'undefined') return
  const newUrl = buildUrlWithSearchParams(window.location, params)
  window.history.replaceState({}, '', newUrl)
}

export function generateWindowShareableUrl(params: URLSearchParams): string {
  if (typeof window === 'undefined') return ''

  const relativeUrl = buildUrlWithSearchParams(window.location, params)
  return `${window.location.protocol}//${window.location.host}${relativeUrl}`
}
